import { dataUrlToFile, saveFile } from '@modules/file-menagement/fileUtils';
import { isFuture, isSameWeek, isToday, isYesterday, parseISO } from 'date-fns';
import {
  type ChatMessageListItem,
  ChatMuteType,
  type ChatTextMuteSettingsType,
} from 'src/@types/chat';
import { useLocales } from 'src/locales';

export const formatDateDivider = (dateStr: string) => {
  const { currentLang, translate } = useLocales();
  const date = parseISO(dateStr);

  if (isToday(date)) {
    return translate('shared.buttons.today');
  }

  if (isYesterday(date)) {
    return translate('shared.buttons.yesterday');
  }

  if (isSameWeek(date, new Date())) {
    // return weekday
    return date.toLocaleString(currentLang.value, { weekday: 'long' });
  }

  // if (isSameMonth(date, new Date())) {
  //   // return month
  //   return date.toLocaleString('en-US', { month: 'long' });
  // }

  return date.toLocaleString(currentLang.value, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatMessageTime = (dateStr: string) => {
  const { currentLang } = useLocales();
  const date = parseISO(dateStr);
  return date.toLocaleTimeString(currentLang.value, {
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const isVideoMimeType = (mimeType: string) =>
  ['video/mp4', 'video/ogg', 'video/webm'].includes(mimeType);

export const isImageMimeType = (mimeType: string) =>
  mimeType.startsWith('image');

export const checkIfMutedChannel = (
  userId: string,
  message: ChatMessageListItem | undefined,
  muteSettings: ChatTextMuteSettingsType | undefined,
) => {
  if (!muteSettings) return false;
  const { mute, muteUntil } = muteSettings;
  if (mute === ChatMuteType.NOTMUTED) return true;
  if (mute === ChatMuteType.MUTEDUNTIL)
    return isFuture(new Date(muteUntil || ''));
  if (mute === ChatMuteType.MENTIONS) {
    return (
      !message?.content?.includes(`data-type="mention" data-id="${userId}"`) ||
      false
    );
  }
  return false;
};

export const handleDownloadChatMedia = async (
  messageMediaContent: string,
  fileName?: string,
  mimeType?: string,
) => {
  if (!fileName || !mimeType) return;
  const { fileUrl } = await dataUrlToFile(
    messageMediaContent,
    fileName,
    mimeType,
  );
  await saveFile(fileName, fileUrl);
};
